<app-card-shell padding="lg">
  <div class="flex flex-col gap-6">
    <div>
      <h2 class="sales-order-integration-tab__title">
        {{ 'COMPONENTS.SALES_ORDERS.SECTIONS.INTEGRATION' | translate }}
      </h2>
      <p class="sales-order-integration-tab__hint">
        {{ 'COMPONENTS.SALES_ORDERS.SECTIONS.INTEGRATION_DESCRIPTION' | translate }}
      </p>
    </div>

    @if (integrationView; as view) {
      <div class="sales-order-integration-tab__grid">
        <div class="sales-order-integration-tab__card">
          <p class="sales-order-integration-tab__meta-label">
            {{ 'COMPONENTS.SALES_ORDERS.INTEGRATION.SOURCE_LABEL' | translate }}
          </p>
          <p class="sales-order-integration-tab__meta-value">{{ view.sourceLabelKey | translate }}</p>
        </div>

        <div class="sales-order-integration-tab__card">
          <p class="sales-order-integration-tab__meta-label">
            {{ 'COMPONENTS.SALES_ORDERS.INTEGRATION.LAST_MODIFIED' | translate }}
          </p>
          <p class="sales-order-integration-tab__meta-value">
            {{ view.lastModified ? (view.lastModified | date: 'yyyy-MM-dd HH:mm') : '-' }}
          </p>
        </div>

        @if (view.businessCentralId) {
          <div class="sales-order-integration-tab__card sales-order-integration-tab__card--wide">
            <p class="sales-order-integration-tab__meta-label">
              {{ 'COMPONENTS.SALES_ORDERS.INTEGRATION.EXTERNAL_ID' | translate }}
            </p>
            <p class="sales-order-integration-tab__meta-value sales-order-integration-tab__meta-value--mono">
              {{ view.businessCentralId }}
            </p>
          </div>
        }
      </div>
    }
  </div>
</app-card-shell>
